/*
 * File: d:\projects\AutoFiFront\src\Content\AboutUs\AboutUsHolder.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday March 15th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 6th November 2023 11:02:25
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styles from 'Content/AboutUs/AboutUsHolder.module.css';
import translator from 'MultiLanguage/TranslationWrapper';
import EngagementAboutUs from 'Content/AboutUs/Engagements/EngagementAboutUs';
import Knowledge from 'Content/SVG/EngagementSVG/Knowledge';
import Hands from 'Content/SVG/EngagementSVG/Hands';
import Transparency from 'Content/SVG/EngagementSVG/Transparency';
import Serenity from 'Content/SVG/EngagementSVG/Serenity';
import Values from 'Content/AboutUs/Values/Values';
import Passion from 'Content/SVG/ValuesSVG/Passion';
import Trust from 'Content/SVG/ValuesSVG/Trust';
import Proximity from 'Content/SVG/ValuesSVG/Proximity';
import Respect from 'Content/SVG/ValuesSVG/Respect';

function AboutUsHolder (){
    const knowledge = ["aboutUs.ourEngagementsKnowledgeText1"];
    const relation = ["aboutUs.ourEngagementsRelationText1"];
    const transparency = ["aboutUs.ourEngagementsTransparencyText1"];
    const event = ["aboutUs.ourEngagementsEventText1","aboutUs.ourEngagementsEventText2"];
    const ourStory = ["aboutUs.ourStoryText1"];
    const values = [
        {
            title:"passion",
            icon:<Passion fill='var(--theme-color)' />
        },
        {
            title:"respect",
            icon:<Respect fill='var(--theme-color)' />
        },
        {
            title:"proximity",
            icon:<Proximity fill='var(--theme-color)' />
        },
        {
            title:"trust",
            icon:<Trust fill='var(--theme-color)' />
        },
    ];

    return (
        <div className={`${styles.aboutUsHolder}`}>
            <h1 className={`${styles.titleAboutUs}`}> <span className={`${styles.spanColor}`}>{translator.decode("aboutUs.whoWeArePart1")}</span>{translator.decode("aboutUs.whoWeArePart2")}</h1>
            <div className={`${styles.ourStory}`}>
                <h2 className={`${styles.subTitleAboutUs}`}>{translator.decode("aboutUs.ourStory")}</h2>
                <EngagementAboutUs text={ourStory} />
            </div>
            <h2 className={`${styles.engagementTitle}`}>{translator.decode("aboutUs.ourEngagements")}</h2>
            <div className={`${styles.doubleBlock}`}>
                <EngagementAboutUs title={"aboutUs.ourEngagementsKnowledge"} text={knowledge} icon={<Knowledge width="3rem" fill='var(--theme-color)'/>} />
                <EngagementAboutUs title={"aboutUs.ourEngagementsRelation"} text={relation} icon={<Hands width="3rem" fill='var(--theme-color)'/>} />
            </div>
            <div className={`${styles.doubleBlock}`}>
                <EngagementAboutUs title={"aboutUs.ourEngagementsTransparency"} text={transparency} icon={<Transparency width="3rem" fill='var(--theme-color)'/>} />
                <EngagementAboutUs title={"aboutUs.ourEngagementsEvent"} text={event} icon={<Serenity width="3rem" fill='var(--theme-color)'/>} />
            </div>
            <div id='values' className={`${styles.valuesBlock}`}>
                <h2 className={`${styles.valuesTitle}`}>{translator.decode("aboutUs.ourValues")}</h2>
                <div className={`${styles.values}`}>
                    {
                        values.map((item, index)=>{return <Values key={item.title + index} text={item.title} icon={item.icon} themeColor={''} />})
                    }
                </div>
            </div>
        </div>
    );
}

export default AboutUsHolder;
